import $axios from '@/service/httpServer'


export const getApplyInfo = params=>$axios.get(`/pdp/xcx/apply/applyInfos`, params); //获取申报列表

export const getApplyStatistics =params=>$axios.get(`/pdp/xcx/apply/statistics`, params)  //获取申报概览

export const getApplyStatisticsByid = params=>$axios.get(`/pdp/xcx/apply/statisticsInfo`, params); //根据合同id查询产值申报统计

export const getApplyInfoByid = params=>$axios.get(`/pdp/xcx/apply/logInfo`, params); //根据合同id查询产值申报记录